<template>
  <v-card class="mx-auto pa-5">
    <v-card-title class="mx-0 px-0">Update</v-card-title>
    <v-row>
      <v-col cols="6"><v-text-field dense outlined label="Username" v-model="item.username"/></v-col>
      <v-col cols="6"><v-text-field dense outlined label="Password" v-model="item.password"/></v-col>
      <v-col cols="12"><v-textarea dense outlined label="Configs" v-model="item.configs"></v-textarea></v-col>

    </v-row>
    <v-card-actions class="mx-0 pa-0">
      <v-spacer></v-spacer>
      <v-btn color="secondary" text @click="onCancel">Cancel</v-btn>
      <v-btn color="primary" text @click="processUpdate">Update</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {mapActions} from 'vuex'
import cloneDeep from 'clone-deep';

export default {
  name: 'UpdateOne789',
  props: ['selectedItem', 'onUpdated', 'onCancel'],
  data: () => ({
    item: {}
  }),
  methods: {
    ...mapActions({
      updateItem: 'one_789/update',
    }),
    processUpdate() {
      this.updateItem(this.item).then(() => {
        this.onUpdated();
        this.item = {};
      });
    }
  },
  watch: {
    selectedItem: {
      handler() {
        if (this.selectedItem) this.item = this.cloneDeep(this.selectedItem);
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
